import React, { useEffect, useState } from "react";
import {
    Avatar,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Box,
    Typography,
    IconButton,
    useTheme,
    InputLabel,
    TextField,
    Grid,
    MenuItem,
    Button,
    DialogContent,
    DialogTitle,
    DialogContentText,
    DialogActions,
    Dialog,
} from "@mui/material";
import { CheckCircle, Cancel, Autorenew } from "@mui/icons-material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import Colors from "../../../assets/styles";
import UserServices from "../../../api/UserServices/index";
import Loader from "../../../components/Loader";
import { useForm } from "react-hook-form";
import SimpleDialog from "../../../components/Dialog";
import VoucherServices from "../../../api/VoucherServices/index";
import { ErrorHandler } from "../../../utils/ErrorHandler";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { ErrorToaster, SuccessToaster } from "../../../components/Toaster";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import EditIcon from "@mui/icons-material/Edit";
import StarIcon from "@mui/icons-material/Star";

import DeleteIcon from "@mui/icons-material/Delete";
import Pagination from "../../../components/Pagination";
import EqualizerIcon from '@mui/icons-material/Equalizer';
import ConfirmationDialog from "../../../assets/Dialog";
import OrderServices from "../../../api/orderServices/order.index";


const Blogs = () => {
    const navigate = useNavigate();
    const [order, setOrder] = useState("asc");

    const [orderBy, setOrderBy] = useState("created_at");
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sortedRows, setSortedRows] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectStatus, setSelectStatus] = useState();
    const [selectedUser, setSelectedUser] = useState("");
    const [users, setUsers] = useState([]);
    const [blogs, setBlogs] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(10);

    const [count, setCount] = useState(0);
    const [confirmationDialog, setConfirmationDialog] = useState(false)
    const [starredRows, setStarredRows] = useState({});

    const onSubmit = (data) => {
        console.log("Search Query:", data.search);
        getUsers(page, rowsPerPage);
    };
    // State for dialog
    const [open, setOpen] = useState(false);
    const [rowToDelete, setRowToDelete] = useState(null);

    const handleDeleteClick = async () => {
        setLoading(true);
        let params = {
            id: selectedUser?._id
        }
        try {
            const { data, responseCode, message } = await OrderServices.deleteBlog(params);
            getUsers()
            handleClose();

        } catch (error) {
            console.error("Error while fetching users:", error);
        }
    };

    // Close dialog
    const handleClose = () => {
        setOpen(false);
        setRowToDelete(null);
    };

    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors },
    } = useForm();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    console.log(baseUrl);

    const tableHead = [
        { name: "title", label: "Title" },
        { name: "email", label: "Short Description" },
        { name: "available_credit", label: "Created At" },
        { name: "action", label: "Action" },
    ];

    useEffect(() => {
        getUsers(page, rowsPerPage);
    }, []);

    useEffect(() => {
        handleSort(orderBy, order);
    }, [blogs]);

    const getUsers = async (page, limit) => {
        let search = getValues("search");
        const Page = page ? page : currentPage;
        const Limit = limit ? limit : pageLimit;
        setCurrentPage(Page);
        setPageLimit(Limit);
        let params = {
            page: Page,
            limit: Limit,
            vendor_id: selectedVendor
        };
        setLoading(true);
        try {
            const { data, responseCode, message } = await UserServices.getBlogs(
                page,
                Limit,
                search,
                selectedVendor
            );
            console.log(data?.customers);
            setBlogs(data?.blogs);
            setCount(data?.count);
            setLoading(false);
        } catch (error) {
            console.error("Error while fetching users:", error);
            setLoading(false);
        }
    };
    const updateUser = async (row) => {
        console.log(row);
        const obj = {
            is_premium: row?.is_premium ? false : true,
            user_id: row?._id,
        };
        setLoading(true);
        try {
            const { data, responseCode, message } = await UserServices.updateUser(
                obj
            );
            setLoading(false);
            getUsers(page, rowsPerPage);
        } catch (error) {
            console.error("Error while fetching users:", error);
        }
    };

    const handleSort = (column, direction) => {
        const isAsc = direction === "desc";
        const sorted = [...blogs].sort((a, b) => {
            let aValue = a[column];
            let bValue = b[column];

            // Handle nested properties
            if (column === "customer") {
                aValue = `${a.customer.first_name} ${a.customer.last_name}`;
                bValue = `${b.customer.first_name} ${b.customer.last_name}`;
            } else if (column === "details") {
                aValue = a.details
                    .map((detail) => `${detail.size} ${detail.qty} ${detail.design}`)
                    .join(", ");
                bValue = b.details
                    .map((detail) => `${detail.size} ${detail.qty} ${detail.design}`)
                    .join(", ");
            }

            if (aValue < bValue) {
                return isAsc ? -1 : 1;
            }
            if (aValue > bValue) {
                return isAsc ? 1 : -1;
            }
            return 0;
        });

        console.log(direction);
        setSortedRows(sorted);
        setOrder(direction);
        setOrderBy(column);
    };

    const handleSortRequest = (column) => {
        const isAsc = orderBy === column && order === "asc";
        handleSort(column, isAsc ? "desc" : "asc");
    };

    const handleChangePage = (event, newPage) => {
        const updatedPage = newPage;
        setPage(updatedPage);
        getUsers(updatedPage, rowsPerPage);
    };
    const handleChangePage1 = (event, newPage) => {
        const updatedPage = newPage + 1;
        setPage(updatedPage);
        getUsers(updatedPage, rowsPerPage);
    };
    const [vendors, setVendors] = useState([])
    const [selectedVendor, setSelectedVendor] = useState(null)
    const getMerchants = async (page, limit) => {
        let search = getValues("search");
        const Page = page ? page : currentPage;
        const Limit = limit ? limit : pageLimit;
        setCurrentPage(Page);
        setPageLimit(Limit);
        let params = {
            page: Page,
            limit: Limit,
        };
        setLoading(true);
        try {
            const { data, responseCode, message } = await UserServices.getMerchants(
                page,
                Limit,
                search
            );
            console.log(data?.vendors);
            setVendors(data?.vendors);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Error while fetching users:", error);
        }
    };



    useEffect(() => {
        if (selectedUser) {
            console.log(selectedUser);
            setValue("status", selectedUser.status);
            setSelectStatus(selectedUser.status);
        }
    }, [openDialog, selectedUser, setValue]);
    useEffect(() => {
        getMerchants()
    }, [])


    return (
        <>
            <ConfirmationDialog
                open={confirmationDialog}
                onClose={() => setConfirmationDialog(false)}
                message={"You Have Unsaved Changes on this Page"}
                action={() => {
                    setConfirmationDialog(false);

                    handleDeleteClick()
                }}
            />
            <Paper
                sx={{
                    boxShadow: "rgba(0, 0, 0, 0.02) 0px 3.5px 5.5px",
                    borderRadius: "15px",
                    p: 2,
                }}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ mt: 8 }}
                    >
                        {/* Left side: Search input + button */}
                        <Grid item xs={12} sm={8} md={6}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={8}>
                                    <TextField
                                        label="Search"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        {...register("search", {
                                            onChange: (event) => console.log("asd"),
                                        })}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        sx={{
                                            height: "40px",
                                            textTransform: "capitalize",
                                            backgroundColor: "#0f172a",
                                            color: "white",
                                            ":hover": {
                                                backgroundColor: "#0f172a",
                                                color: "white",
                                            },
                                        }}
                                    >
                                        Search
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* Right side: Create Button */}
                        <Grid item>
                            <Button
                                onClick={() => navigate("/create-blog")} // change route as needed
                                sx={{
                                    height: "40px",
                                    textTransform: "capitalize",
                                    backgroundColor: "#0f172a",
                                    color: "white",
                                    px: 3,
                                    ":hover": {
                                        backgroundColor: "#0f172a",
                                    },
                                }}
                            >
                                Create
                            </Button>
                        </Grid>
                    </Grid>

                </form>

                {sortedRows?.length > 0 && <TableContainer sx={{ mt: 2 }}>
                    <Box sx={{ m: 2, display: "flex", justifyContent: "end" }}></Box>
                    <Table>
                        <TableHead
                            sx={{
                                position: "sticky",
                                top: "0",
                                background: "#0f172a",
                                zIndex: "1",
                            }}
                        >
                            <TableRow>
                                {tableHead.map((cell) => (
                                    <TableCell key={cell.name}>
                                        <TableSortLabel
                                            active={orderBy === cell.name}
                                            direction={orderBy === cell.name ? order : "asc"}
                                            onClick={() => handleSortRequest(cell.name)}
                                            sx={{
                                                svg: {
                                                    fontSize: "12px",
                                                    color: `${Colors.grey} !important`,
                                                },
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    color: Colors.white,
                                                    fontSize: "12px",
                                                    fontWeight: 700,
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {cell.label}
                                            </Typography>
                                        </TableSortLabel>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? (
                                <TableRow>
                                    <TableCell colSpan={tableHead?.length + 1}>
                                        <Loader width="40px" height="40px" />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                sortedRows.map((row) => (
                                    <TableRow key={row._id}>
                                        <TableCell>{row?.title}</TableCell>
                                        <TableCell>{row?.short_description}</TableCell>

                                        <TableCell>
                                            {" "}
                                            {moment(row?.created_at).format("DD-MM-YYYY")}{" "}
                                        </TableCell>
                                        <TableCell

                                        >
                                            <Box>
                                                {/* Update Button */}
                                                <IconButton
                                                    onClick={() => navigate(`/update-blog/${row?._id}`)}
                                                    sx={{
                                                        color: "#1976d2",
                                                        "&:hover": { backgroundColor: "rgba(25,118,210,0.1)" },
                                                    }}
                                                >
                                                    <EditIcon sx={{ cursor: "pointer" }} />
                                                </IconButton>

                                                {/* Delete Button */}
                                                <IconButton
                                                    onClick={() => {
                                                        setSelectedUser(row)
                                                        setConfirmationDialog(true)

                                                    }}
                                                    sx={{
                                                        color: "#d32f2f",
                                                        "&:hover": { backgroundColor: "rgba(211,47,47,0.1)" },
                                                    }}
                                                >
                                                    <DeleteIcon sx={{ cursor: "pointer" }} />
                                                </IconButton>
                                            </Box>
                                            {" "}

                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>

                    {/* Confirmation Dialog */}
                </TableContainer>}

                {/* ========== Pagination ========== */}
                {sortedRows?.length > 0 && <Pagination
                    currentPage={currentPage}
                    pageSize={pageLimit}
                    onPageSizeChange={(size) => getUsers(1, size.target.value)}
                    tableCount={sortedRows?.length}
                    totalCount={count}
                    onPageChange={(page) => getUsers(page, "")}
                />}
            </Paper>
        </>
    );
};

export default Blogs;
